export default __webpack_public_path__ + "1f31b19a9207be5eaf79bbb2314829d3.svg";